export default "__VITE_ASSET__Bp21siKD__"